import axios from 'axios';
import { standardErrorInterceptor } from './standardErrorInterceptor';

let baseURL = '/';
if ((window as any).appConfig && (window as any).appConfig.serverContextPath) {
  baseURL = (window as any).appConfig.serverContextPath;
} else if ((window as any).serverContextPath) {
  baseURL = (window as any).serverContextPath;
}

const baseAxios = axios.create({
  baseURL,
  headers: { Pragma: "no-cache" },
});


baseAxios.interceptors.response.use(undefined, standardErrorInterceptor);

export { baseAxios };
